// import React from "react";
// import Sidebar from "../sidebar/Sidebar";
// // import TopBar from "../topbar/Topbar";
// import TopBar from "../topbar/index";
// import useAuth from "../../../hooks/useAuth";
// import { Outlet } from "react-router-dom";
// import { useSelector, useDispatch } from "../../../store/index";
// import { RootState } from "../../../store";
// import { setHoverOpen } from "../../../store/slices/sidebarSlice";
// import { useCallback } from "react";

// const Layout: React.FC = () => {
//   const { logout } = useAuth();
//   const dispatch = useDispatch();
//   // const sidebarOpen = useSelector((state: RootState) => state.sidebarState.open);
//   const { manualOpen, hoverOpen } = useSelector(
//     (state: RootState) => state.sidebarState
//   );

//   // Sidebar is open if manualOpen OR hoverOpen is true
//   const sidebarOpen = manualOpen || hoverOpen;

//   const handleMouseEnter = () => {
//     console.log("Mouse entered - setting hoverOpen true");
//     dispatch(setHoverOpen(true));
//   };

//   const handleMouseLeave = () => {
//     console.log("Mouse left - setting hoverOpen false");
//     dispatch(setHoverOpen(false));
//   };

//   // const handleMouseEnter = useCallback(() => {
//   //   console.log("Mouse entered - setting hoverOpen true");
//   //   dispatch(setHoverOpen(true));
//   // }, [dispatch]);

//   // const handleMouseLeave = useCallback(() => {
//   //   console.log("Mouse left - setting hoverOpen false");
//   //   dispatch(setHoverOpen(false));
//   // }, [dispatch]);

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: "hidden",
//       }}
//     >
//       {/* TopBar */}
//       <div
//         style={{
//           height: "60px",
//           backgroundColor: "#fff",
//           boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
//           zIndex: 1000,
//           position: "fixed",
//           width: "100%",
//           top: 0,
//           left: 0,
//         }}
//       >
//         {/* <TopBar
//           // onSideBarToggle={() => dispatch(toggleSidebar())}
//           sidebarOpen={sidebarOpen}
//           onLogout={logout}
//         /> */}
//         <TopBar />
//       </div>

//       {/* Main Layout */}
//       <div
//         style={{
//           //   display: "flex",
//           //   flexGrow: 1,
//           marginTop: "50px",
//           //   height: "calc(100vh - 60px)",
//           //   overflow: "hidden",
//         }}
//       >
//         {/* Sidebar
//         <div
//           style={{
//             width: sidebarOpen ? "270px" : "80px",
//             transition: "width 0.3s ease-in-out",
//             position: "fixed",
//             height: "calc(100vh - 60px)",
//             top: "60px",
//             left: 0,
//             overflowY: "auto",
//             zIndex: 900,
//           }}
//           // onMouseEnter={() => !sidebarOpen && dispatch(openSidebar())}
//           // onMouseLeave={() => sidebarOpen && dispatch(closeSidebar())}
//           // onMouseEnter={() => dispatch(setHoverOpen(true))}
//           // onMouseLeave={() => dispatch(setHoverOpen(false))}
//           onMouseEnter={handleMouseEnter}
//           onMouseLeave={handleMouseLeave}
//         >
//           <Sidebar sidebarOpen={sidebarOpen} />
//         </div> */}

//         {/* Content Area */}
//         <div
//           style={{
//             flexGrow: 1,
//             // marginLeft: sidebarOpen ? "270px" : "80px",
//             transition: "margin-left 0.3s ease-in-out",
//             display: "flex",
//             flexDirection: "column",
//             padding: "13px",
//             height: "calc(100vh - 50px)",
//             overflowY: "auto",
//           }}
//         >
//           <div
//             style={{
//               borderRadius: "8px",
//               padding: "8px",
//               boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//               flexGrow: 1,
//               height: "100%",
//               overflow: "auto",
//             }}
//           >
//             <Outlet />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;

import React from "react";
import TopBar from "../topbar/index"; // Your topbar component with menu dropdown
import { Outlet } from "react-router-dom";
import logo from "../../../../src/logo/logo.png"

const Layout: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Fixed Topbar */}
      <div
        style={{
          height: "60px",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          backgroundColor: "#fff",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <TopBar />
      </div>

      {/* Spacer to push content below topbar */}
      <div style={{ height: "60px" }} />

      {/* Content area below topbar */}
      <div
        style={{
          flexGrow: 1,
          overflowY: "auto",
          // padding: "13px",
          padding: "13px -1px", // 13px top/bottom, 6px left/right
          height: `calc(100vh - 60px)`,
        }}
      >
        <Outlet />
      </div>
      {/* Bottom-Right Logo */}
      {/* <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "30px",
          width: "180px",          // rectangle width
          height: "70px",          // rectangle height
          background: "#f1f1f1ff",   // light tile color
          borderRadius: "12px",    // smooth corners
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 3px 10px rgba(0,0,0,0.15)", // clean shadow
          zIndex: 2000,
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{
            height: "180%",         // scale logo clearly
            objectFit: "contain",
          }}
        />
      </div> */}
      {/* <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "30px",
          width: "115px",
          height: "115px",
          borderRadius: "60%",
          backgroundColor: "#ffffffdd", // white with slight transparency
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
          backdropFilter: "blur(4px)",
          zIndex: 2000,
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{
            width: "105%", // increases clarity
            // height: "200%",
            objectFit: "contain",
          }}
        />
      </div> */}

    </div>
  );
};

export default Layout;
